import Icon from "./Icon";

type MessageProps = { type: string; icon: string; children: any };

const Message = ({ icon, type = "default", children }: MessageProps): JSX.Element => {
  return (
    <div className={`feedback-message feedback-message--${type}`}>
      {icon && <Icon name={icon} />}
      {children}
    </div>
  );
};

export default Message;
